let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jaR1c")).then(() => parcelRequire('llxNs'));